import SwiperCore, { Navigation, Pagination } from 'swiper/core';

SwiperCore.use([Navigation, Pagination]);

function initSlider() {
    const swiper = new SwiperCore('.swiper-container', {
        observer: true,
        observeParents: true,
        loop: false,

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}


let $productCarousel = $('.product-carousel');
if ($productCarousel.length > 0) {
    $productCarousel.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true
    });
}


$(function () {
    let $machineFilter = $('.filter-mtype');
    const $priceFilter = $('.filter-price');
    const type = $('#product-tabs').data('type') || 'products';

    function activateTab(hash) {
        $(`.content`).removeClass('active');
        $(`.content${hash}`).addClass('active');
        $(`.tab-title`).removeClass('active');
        $(`.tab-title a[href="${hash}"]`).parent().addClass('active');
    }

    // attempts to set the state of the page based on the URL
    function processLocation(location) {
        const params = new URLSearchParams(location.search);

        if (location.hash) {
            if (location.hash == '#fabrics') {
                products.filter.setUrl(location.origin, location.pathname, '#machines');
                activateTab('#machines');
            } else {
                activateTab(location.hash);
            }
        } else {
            products.filter.setUrl(location.origin, location.pathname, '#machines');
            activateTab('#machines');
        }

        const pathType = params.get('mtype');
        if (pathType) {
            $machineFilter.val(pathType);
            products.filter['mtype'][products.filter.activeTab()] = [pathType];
            products.filter.params.set('mtype', pathType);
        } else {
            $machineFilter.val('');
            products.filter['mtype'][products.filter.activeTab()] = [];
            products.filter.params.delete('mtype');
        }

        const pathBrand = params.get('brand');
        if (pathBrand) {
            $('.filter-brand').val(pathBrand);
            products.filter['brand'][products.filter.activeTab()] = [pathBrand];
            products.filter.params.set('brand', pathBrand);
        } else {
            $('.filter-brand').val('');
            products.filter['brand'][products.filter.activeTab()] = [];
            products.filter.params.delete('brand');
        }

        const pathColor = params.get('color');
        if (pathColor) {
            $('.filter-color').val(pathColor);
            products.filter['color'][products.filter.activeTab()] = [pathColor];
            products.filter.params.set('color', pathColor);
        } else {
            $('.filter-color').val('');
            products.filter['color'][products.filter.activeTab()] = [];
            products.filter.params.delete('color');
        }

        const pathTerms = params.get('terms');
        if (pathTerms) {
            $('.search-input').val(pathTerms);
            products.filter['terms'][products.filter.activeTab()] = [pathTerms];
            products.filter.params.set('terms', pathTerms);
        } else {
            $('.search-input').val('');
            products.filter['terms'][products.filter.activeTab()] = [];
            products.filter.params.delete('terms');
        }

        products.filter.runFilter();
        console.log('process location: ', params, pathType, pathBrand, pathTerms);
    }

    if ($machineFilter.length) {
        window.products = {};
        window.products.filter = {
            params: new URLSearchParams(location.search),
            mtype: [],
            promo: [],
            brand: [],
            color: [],
            terms: [],

            activeTab: function () {
                return $('div.active').attr('id');
            },

            populateTerms: function () {
                let activeTab = products.filter.activeTab();
                let tabTerms = $('#' + activeTab + ' .search-input').val();
                products.filter.setFilter('terms', tabTerms);
            },

            setUrl: function (origin = location.origin, pathname = location.pathname, hash = location.hash) {
                if (products.filter.params.toString()) {
                    history.pushState({}, '', origin + pathname + '?' + products.filter.params.toString() + hash);
                } else {
                    history.pushState({}, '', origin + pathname + hash);
                }
            },

            setTabUrl: function (slug) {
                history.pushState({}, '', location.origin + location.pathname + slug);
            },

            setFilter: function (f, value) {
                let activeTab = products.filter.activeTab();
                products.filter[f][activeTab] = value;
                if (value) {
                    products.filter.params.set(f, value);
                } else {
                    products.filter.params.delete(f);
                }
                products.filter.setUrl();
                products.filter.runFilter();
            },

            clearFilters: function () {
                $machineFilter.val('');
                products.filter['mtype'][products.filter.activeTab()] = [];
                products.filter.params.delete('mtype');

                $('.filter-brand').val('');
                products.filter['brand'][products.filter.activeTab()] = [];
                products.filter.params.delete('brand');

                $('.filter-color').val('');
                products.filter['color'][products.filter.activeTab()] = [];
                products.filter.params.delete('color');

                $('.search-input').val('');
                products.filter['terms'][products.filter.activeTab()] = [];
                products.filter.params.delete('terms');

                $priceFilter.val('');

                products.filter.runFilter();
            },

            runFilter: function (emptyResultsBeforeAppending = true, injectedFilters = {}, onFinishCallback = null) {
                let activeTab = products.filter.activeTab();
                let data = {
                    [window.csrfTokenName]: window.csrfTokenValue,
                    mtype: this.mtype[activeTab],
                    promo: this.promo[activeTab],
                    brand: this.brand[activeTab],
                    color: this.color[activeTab],
                    terms: this.terms[activeTab],
                    activeTab: activeTab
                };
                data = {...data, ...injectedFilters};
                $.get('/ajax-' + type, data, function (results) {
                    var tbody = 'tbody#prod-' + activeTab;
                    if(emptyResultsBeforeAppending){
                        $(tbody).empty();
                    }

                    $(tbody).append(results);
                    if(type === 'videos'){
                        // reinstantiate listener
                        window.initMicroModal()
                    }
                    if(onFinishCallback) {
                        onFinishCallback();
                    }
                })
            }
        };

        $('#prod-machines').on('click', '.show-more-videos-button', function(){
            console.log('loading more videos...');
            const button = $(this);
            button.attr('disabled', 'disabled');
            button.addClass('loading');
            products.filter.runFilter(false, {
                limit: button.data('limit'),
                offset: button.data('offset')
            }, function(){
                console.log('finished injecting videos');
                // button.removeClass('loading');
                // button.removeAttr('disabled');
                button.closest('.show-more-videos-button-wrapper').remove();
            })
        })

        // Change machine type
        $machineFilter.on('change', function () {
            products.filter.setFilter('mtype', this.value);
        });

        // Change brand
        $('.filter-brand').on('change', function () {
            products.filter.setFilter('brand', this.value);
        });

        $('.filter-color').on('change', function () {
            products.filter.setFilter('color', this.value);
        });

        // Change current promotions
        $('.filter-promo').on('change', function () {
            products.filter.setFilter('promo', this.value);
        });

        // Show only products in price range
        $priceFilter.on('change', function () {
            const value = $(this).val();
            let range = "all";
            if(value !== ""){
                range = value.split('|');
            }

            $("[data-price]").hide().filter(function(){
                const price = $(this).attr("data-price");

                if(range === "all"){
                    return true;
                }

                if(range.length === 1){
                    return price > parseInt(range[0]);
                }

                const lowEndTest = price > parseInt(range[0]);
                const topEndTest = price <= parseInt(range[1]);

                return lowEndTest && topEndTest;
            }).show();
        });

        // Change page tabs
        $('.tab-title').on('click.tab-change', function () {
            products.filter.setTabUrl($(this).find('a').attr('href'));
            products.filter.clearFilters();
            initSlider();
        });

        // Change terms
        $('.search-input')
            .on('blur', function () {
                products.filter.populateTerms();
            })
            .on('keypress', function (e) {
                if (e.which === 13) {
                    products.filter.populateTerms();
                }
            });

        $(document).ready((event) => {
            processLocation(window.location);

            window.addEventListener('popstate', (event) => {
                processLocation(window.location);
            });
        });

        initSlider();
    }

    initSlider();
});

$(document).on('click', '.js-add-to-cart-and-redirect', function(e){
    console.log('Clicked Buy Now button');
    const productId = $(this).data('product-id');

    if(productId){
        let data = {};

        data["productId"] = productId;
        data[window.csrfTokenName] = window.csrfTokenValue;

        window.alert.popup("Adding the product to cart", "info", {
            showLoading: true,
            showCloseButton: false,
            showConfirmButton: false,
            showCancelButton: false,
            cancelButtonText: null,
            allowOutsideClick: false,
            width: "25em"
        });

        $.ajax({
            method: 'POST',
            url: '/actions/montavilla/commerce/add-to-cart',
            data: data,
            timeout: 20000,
            success: function (response){
                if(typeof response.success !== undefined){
                    if(response.success === true){
                        window.alert.close();
                        window.location.href = "/cart";
                    }
                    else {
                        if(response.message){
                            console.error(response.message);
                        }
                        window.alert.popup('Unfortunately we could not add the product to your cart. Please click on the "Read More" link below the product to open the product page and add the product to cart from there.', 'warning', {
                            title: 'An error occurred while adding the product to cart'
                        });
                    }
                }
            },
            error: function(jqXHR, textStatus, errorThrown){
                if(textStatus === 'timeout'){
                    console.error("Ajax timeout");
                    window.alert.popup('Unfortunately adding the product to cart took too long and the operation has been cancelled. Please try again or click on the "Read More" link below the product "Buy Now" button and then add the product to the cart from the "Buy Now" button inside the product page.', 'error', {
                        title: 'Adding the product to cart took too long',
                    });
                }
                else {
                    console.error("Request error");
                    window.alert.popup('Unfortunately we could not add the product to your cart. Please click on the "Read More" link below the product to open the product page and add the product to cart from there.', 'warning', {
                        title: 'An error occurred while adding the product to cart'
                    });
                }
            }
        })
    }
    else {
        window.alert.popup('Unfortunately we could not add the product to your cart. Please click on the "Read More" link below the product to open the product page and add the product to cart from there.', 'warning', {
            title: 'The product id is missing'
        });
    }
});